import React from "react";
import {
  AppLayoutViewDetail,
  Block,
  Button,
  Card,
  Col,
  Icon,
  LabelValue,
  LabelValueList,
  List,
  ListItem,
  Row,
  Space,
  Tag,
  TagIntent,
  Text,
  Title,
  VF,
} from "@mc/ui-v4";
import { NAVBAR_PROPS } from "../constans";
import { actionApiCall, WaitForQueryData } from "@mc/react-app-v4";
import { useQuery } from "react-query";
import { DETAIL_SPORU } from "../queryKeys";
import {
  Api,
  DokumentVO,
  SoudniSporDetailVO,
  SoudniSporyApi,
  StavSporuBarvaEnum,
  SubjektVO,
} from "../api";
import { AdresaFormatter, formatCurrency, formatDate } from "@mc/react-format";
import { FormatAdresyC } from "@mc/react-format";
import { getTypObjektCaption } from "../captions/TypObjektuCaption";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { DonutProgressChart } from "../components/DonutProgressChart";
import { ViewIntent } from "@mc/ui-v4/dist/common/props";
import { formatSubjekt, getNavbarProps } from "../utils";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useAppConfig } from "@mc/react-app-base";

const getIntent = (value: number, maxValue: number): ViewIntent => {
  const percent = (value / maxValue) * 100;
  if (!percent || percent < 50) {
    return "success";
  } else if (percent < 80) {
    return "warning";
  } else {
    return "danger";
  }
};
const getStavColor = (stav: StavSporuBarvaEnum): TagIntent => {
  switch (stav) {
    case StavSporuBarvaEnum.USPECH:
      return "success";
      return "warning";
    case StavSporuBarvaEnum.NEUSPECH:
      return "danger";
    default:
      return "default";
  }
};
export const SoudniSporDetailPage: React.FC = () => {
  const { search } = useLocation();
  const detailId = queryString.parse(search).id;
  const [idSporu, setIdSporu] = React.useState(detailId);
  const SoudniSporDetailQuery = useQuery<SoudniSporDetailVO>(
    [DETAIL_SPORU, idSporu],
    async () => (await SoudniSporyApi.getSoudniSporDetail(idSporu)).data
  );
  //slouží pro groupovaní subjektů podle kodeRole
  const groupBy = (arr, property) => {
    return arr?.reduce((acc, cur) => {
      acc[cur[property]] = [...(acc[cur[property]] || []), cur];
      return acc;
    }, {});
  };
  const subjektyGroups: SubjektVO[][] = React.useMemo(() => {
    const groupedValues = groupBy(
      SoudniSporDetailQuery.data?.subjekty,
      "kodRole"
    );
    return groupedValues ? Object.values(groupedValues) : [];
  }, [SoudniSporDetailQuery.data?.subjekty]);
  const downloadFile = React.useCallback(async (value: DokumentVO) => {
    return actionApiCall(async () => {
      const localVarAxiosParamCreator =
        Api.SoudniSporyControllerApiAxiosParamCreator();
      const url = (
        await localVarAxiosParamCreator.getSoudniSporPriloha(value.idDokument)
      ).url;
      window.open(useAppConfig().serverContextPath + url, "_blank");
    });
  }, []);
  return (
    <WaitForQueryData queries={[SoudniSporDetailQuery]}>
      {() => {
        const data = SoudniSporDetailQuery.data;
        const soudniSpor = data?.soudniSporVO;
        return (
          <AppLayoutViewDetail
            header={
              <Space size={"1"} vertical className={"pl-2 w-100"}>
                <div className={"d-flex w-100"}>
                  <Title level={1}>
                    {soudniSpor?.subjektNazev}{" "}
                    <Text size={"normal"}>
                      {formatSubjekt(
                        soudniSpor.subjektAdresa.popisAdresa,
                        soudniSpor.subjektIc,
                        soudniSpor.subjektDatumNarozeni
                      )}
                    </Text>
                  </Title>
                  <div
                    style={{ height: "fit-content" }}
                    className={"d-flex flex-grow-1 justify-content-end"}
                  >
                    <Tag intent={getStavColor(soudniSpor.stavSporuBarva)}>{`${
                      soudniSpor.stavSporu ? soudniSpor.stavSporu : "-"
                    } / ${
                      soudniSpor.vysledekSporu ? soudniSpor.vysledekSporu : "-"
                    }`}</Tag>
                  </div>
                </div>
                <div>
                  <Space size={"1"}>
                    <Tag intent={"secondary"}>
                      {soudniSpor.nazevTypPripad
                        ? soudniSpor.nazevTypPripad
                        : "-"}
                    </Tag>
                    <Tag intent={"secondary"}>
                      {soudniSpor.nazevDruhPripad
                        ? soudniSpor.nazevDruhPripad
                        : "-"}
                    </Tag>
                  </Space>
                </div>
                <Text intent={"secondary"}>{`${
                  soudniSpor.identifikaceKauzy
                    ? soudniSpor.identifikaceKauzy
                    : "-"
                } / ${
                  soudniSpor.oznaceniPripadu ? soudniSpor.oznaceniPripadu : "-"
                }`}</Text>
              </Space>
            }
            navbar={getNavbarProps()}
          >
            <div className={"detail-size"}>
              <Space className={"h-100 pl-2 pt-2 "} vertical size={"2"}>
                <Space size={"2"} className={"d-flex"}>
                  <Card
                    title={"Základní informace"}
                    className={"border w-50"}
                    mode={"view"}
                  >
                    <Block>
                      <Row>
                        <Col>
                          <div>
                            <LabelValue label={"Vlastník případu (oj)"}>
                              {data.soudniSporVO?.ojVlastnika}
                            </LabelValue>
                            <LabelValue label={"Zodpovědná osoba"}>
                              {data.zodpovednaOsoba}
                            </LabelValue>
                            <LabelValue label={"Spisová značka MHMP"}>
                              {data.spisovaZnacka}
                            </LabelValue>
                          </div>
                        </Col>
                        <Col>
                          <div>
                            <LabelValue label={"Název soudu"}>
                              {data.nazevSoudu}
                            </LabelValue>
                            <LabelValue label={"Instance soudu"}>
                              {data.instanceSoudu}
                            </LabelValue>
                            <LabelValue label={"Spisová značka soudu"}>
                              {data.soudniZnacka}
                            </LabelValue>
                          </div>
                        </Col>
                        <Col>
                          <div>
                            <LabelValue label={"Datum podání žaloby"}>
                              {formatDate(data.datumPodaniZaloby)}
                            </LabelValue>
                            <LabelValue label={"Datum ukončení sporu"}>
                              {formatDate(data.datumUkonceniSporu)}
                            </LabelValue>
                            <LabelValue label={"Datum nabytí právní moci"}>
                              {formatDate(data.datumNabytiPM)}
                            </LabelValue>
                          </div>
                        </Col>
                      </Row>
                    </Block>
                  </Card>
                  <Card
                    title={"Náklady"}
                    className={"border w-50"}
                    mode={"view"}
                  >
                    <Block>
                      <Row>
                        <Col className={"pr-5"}>
                          <Space vertical size={"2"}>
                            <Title level={3}>Předmět sporu dle rozsudku</Title>
                            <LabelValueList alignRight>
                              <LabelValue horizontal label={"Předmět sporu"}>
                                <Title level={3}>
                                  {formatCurrency(data.predmetSporuCastka)}
                                </Title>
                              </LabelValue>
                              <LabelValue horizontal label={"Příslušenství"}>
                                <Title level={3}>
                                  {formatCurrency(data.prislusenstviCastka)}
                                </Title>
                              </LabelValue>
                              <LabelValue horizontal label={"Náklady řízení"}>
                                <Title level={3}>
                                  {formatCurrency(data.prislusenstviCastka)}
                                </Title>
                              </LabelValue>
                            </LabelValueList>
                          </Space>
                        </Col>
                        <Col>
                          <Space vertical size={"2"}>
                            <Title level={3}>Aktuální náklady sporu</Title>
                            <LabelValueList emptyValue={"-"} alignRight>
                              <LabelValue
                                alignRight
                                horizontal
                                label={"Celkem"}
                              >
                                <Title
                                  intent={getIntent(
                                    data.celkemCastka,
                                    data.limitCastka
                                  )}
                                  level={3}
                                >
                                  {formatCurrency(data.celkemCastka)}
                                </Title>
                              </LabelValue>
                              <LabelValue alignRight label={"Externí"}>
                                <Title level={3}>
                                  {formatCurrency(data.externiCastka)}
                                </Title>
                              </LabelValue>
                              <LabelValue alignRight label={"Limit"}>
                                {data.limitCastka ? (
                                  <Title level={3}>
                                    {formatCurrency(data.limitCastka)}
                                  </Title>
                                ) : (
                                  "-"
                                )}
                              </LabelValue>
                            </LabelValueList>
                          </Space>
                        </Col>
                        <Col xl={"3"} xs={"12"}>
                          <DonutProgressChart
                            actualValue={data.externiCastka}
                            maxValue={data.limitCastka}
                          />
                        </Col>
                      </Row>
                    </Block>
                  </Card>
                </Space>
                <Space size={"2"}>
                  <Card
                    style={{ height: "fit-content" }}
                    className={"border w-50"}
                    mode={"view"}
                  >
                    <Block>
                      {subjektyGroups.length > 0 &&
                        subjektyGroups.map((subjekty, index) => (
                          <>
                            <Title level={3}>{subjekty[0].kodRole}</Title>
                            <List simple>
                              {subjekty.map((subjekt, index) => (
                                <ListItem>{`${
                                  subjekt.subjektNazev
                                }, ${formatSubjekt(
                                  subjekt.subjektAdresa.popisAdresa,
                                  subjekt.subjektIc,
                                  subjekt.subjektDatumNarozeni
                                )}`}</ListItem>
                              ))}
                            </List>
                          </>
                        ))}
                    </Block>
                  </Card>
                  <Card
                    style={{ height: "fit-content" }}
                    title={`Dokumenty (${
                      data.dokumenty?.length ? data.dokumenty.length : 0
                    })`}
                    className={"border w-50"}
                    mode={"view"}
                  >
                    <Block>
                      <List simple>
                        {data.dokumenty?.map((dokument, id) => (
                          <ListItem key={id}>
                            <Space size={"2"}>
                              <Text icon={<Icon icon={faFile} />}>
                                {dokument.pripona}
                              </Text>
                              <Button
                                onClick={() => downloadFile(dokument)}
                                style={"link"}
                              >
                                {dokument.nazev}
                              </Button>
                            </Space>
                          </ListItem>
                        ))}
                      </List>
                    </Block>
                  </Card>
                </Space>
                <Card title={"Objekty"} className={"border w-50"} mode={"view"}>
                  <Block>
                    <List simple>
                      {data.objekty?.map((objekt) => (
                        <ListItem>
                          <LabelValue label={getTypObjektCaption(objekt.typ)}>
                            {objekt.popisObjekt}
                          </LabelValue>
                        </ListItem>
                      ))}
                    </List>
                  </Block>
                </Card>
              </Space>
            </div>
          </AppLayoutViewDetail>
        );
      }}
    </WaitForQueryData>
  );
};
